{
  "dashboard": "Dashboard",
  "bookings": "Bookings",
  "invoices": "Invoices",
  "customers": "Customers",
  "coordinators": "Coordinators & commissions",
  "partners": "Partners & contracts",
  "expenses": "Expenses",
  "reports": "Reports",
  "users": "Users & permissions",
  "lookups": "Lookup lists",
  "settings": "Settings",
  "admin": "Administration",
  "main": "Main menu",
  "menu": "Menu",
  "superOwner": "Main owner",
  "owner": "Owner",
  "logout": "Sign out",
  "portal": {
    "home": "Home",
    "bookings": "My bookings",
    "payouts": "Transfers",
    "title": "Coordinator portal",
    "notifications": "Notifications",
    "notificationsUnread": "Notifications ({{n}} unread)",
    "agreements": "My agreement",
    "customers": "Customers",
    "earnings": "My commissions",
    "role": "Coordinator"
  },
  "account": "My account",
  "guides": "Guides"
}
